export default {
  name: 'gmk-striker',
  override: {
    KC_ESC: 'accent',
    KC_ENT: 'accent',
    KC_PENT: 'accent',
    KC_SPC: 'accent'
  }
};
